import { BannerStack, OnboardingBanner } from '@onboarding'
import EnterpriseDashboard from '../EnterpriseDashboard'
import DashboardPromos from '../PromoBanner'

function DashboardAdmin() {
  return (
    <>
      <BannerStack>
        <OnboardingBanner />
      </BannerStack>
      <EnterpriseDashboard announcements={<DashboardPromos />} />
    </>
  )
}

export default DashboardAdmin
